/**
 * Dawn quick-add cart drawer fix
 * ------------------------------
 * Watches fetch() calls to Shopify's cart endpoints. When a cart/add succeeds,
 * it re-requests the cart-drawer and cart-icon-bubble via Section Rendering API,
 * swaps in the fresh markup, and opens the drawer — without duplicating cart adds.
 * Also closes the cart drawer when clicking the overlay.
 */
(function () {
  'use strict';

  var CART_ENDPOINT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
  var refreshTimer = null;

  function routeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function replaceSection(sourceDoc, selector) {
    var incoming = sourceDoc.querySelector(selector);
    var current = document.querySelector(selector);
    if (incoming && current) { current.innerHTML = incoming.innerHTML; return true; }
    return false;
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    var inner = drawer.querySelector('#CartDrawer') || drawer;
    inner.classList.add('animate', 'active');
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function refreshCart(shouldOpen) {
    var url = routeRoot() + '?sections=' + SECTIONS.join(',');
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function (sections) {
        var parser = new DOMParser();
        Object.keys(sections).forEach(function (key) {
          var html = sections[key];
          if (typeof html !== 'string') return;
          var doc = parser.parseFromString(html, 'text/html');
          if (key === 'cart-icon-bubble') { replaceSection(doc, '#cart-icon-bubble'); }
          else if (key === 'cart-drawer') { if (!replaceSection(doc, 'cart-drawer')) { replaceSection(doc, '#CartDrawer'); } }
          else { replaceSection(doc, '.cart-live-region-text'); }
        });
        if (shouldOpen) openDrawer();
        document.dispatchEvent(new CustomEvent('cart-drawer:refreshed', { bubbles: true }));
      })
      .catch(function () {});
  }

  function scheduleRefresh(shouldOpen) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshTimer = null; refreshCart(shouldOpen); }, 60);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return nativeFetch.apply(this, args).then(function (response) {
        if (CART_ENDPOINT.test(url) && response.ok) { scheduleRefresh(/\/cart\/add/.test(url)); }
        return response;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartUrl = url || '';
      this.addEventListener('load', function () {
        if (CART_ENDPOINT.test(this.__cartUrl) && this.status >= 200 && this.status < 300) {
          scheduleRefresh(/\/cart\/add/.test(this.__cartUrl));
        }
      });
      return nativeOpen.apply(this, arguments);
    };
  }

  ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleRefresh(evt !== 'cart:refresh'); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { scheduleRefresh(true); });
    }
  });

  // --- Close cart drawer when clicking the overlay ---
  document.addEventListener('click', function (e) {
    if (e.target.matches('#CartDrawer-Overlay, .cart-drawer__overlay')) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      } else {
        var inner = document.querySelector('#CartDrawer');
        if (inner) inner.classList.remove('animate', 'active');
        if (drawer) drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }
  });

})();
